import { useMemo } from 'react';
import { usePrintsUiStore } from '../stores/use-prints-ui-store';
import { usePrintsConfigStore } from '../stores/use-prints-config-store';
import { getSelectedFinish } from '../utils/finish-options';

export const useSelectedFinish = () => {
  const selectedFinishName = usePrintsUiStore(
    (state) => state.selectedFinishName,
  );
  const allFinishes = usePrintsConfigStore((state) => state.allFinishes);

  return useMemo(
    () => getSelectedFinish(allFinishes, selectedFinishName),
    [allFinishes, selectedFinishName],
  );
};
